// extracted by mini-css-extract-plugin
export var legendIndicator = "_cx-1";
export var legendRight = "_cx-0";